module.exports = __webpack_public_path__ + "img/shopline-two-en.44370b29.png";